import {base64encode} from "@/utils/common_utils";

export const generateQueryString = (request_generator, api_token) => {
    const encodedUrl = encodeURIComponent(request_generator.url)
    const encodedJS = request_generator.js_snippet ? encodeURIComponent(base64encode(request_generator.js_snippet)) : ""
    const encodedCookies = request_generator.cookies ? encodeURIComponent(request_generator.cookies) : ""
    const encodedWaitForSelector = request_generator.wait_for_selector ? encodeURIComponent(request_generator.wait_for_selector) : ""
    const extractProperties = request_generator.response_type === 'extract' ? encodeURIComponent(request_generator.extract_properties) : ""
    return `url=${encodedUrl}&x-api-key=${api_token}${encodedCookies ? `&cookies=${encodedCookies}` : ""}${encodedJS ? `&js_snippet=${encodedJS}` : ""}${request_generator.proxy_type && request_generator.proxy_type !== "datacenter"  ? `&proxy_type=${request_generator.proxy_type}` : ""}${request_generator.country && request_generator.country !== "ALL"  ? `&proxy_country=${request_generator.country}` : ""}${!request_generator.browser ? `&browser=false` : ""}${request_generator.return_page_source ? `&return_page_source=true` : ""}${encodedWaitForSelector ? `&wait_for_selector=${encodedWaitForSelector}` : ""}${extractProperties ? `&extract_properties=${extractProperties}` : ""}`

}

export const generateProxyUsername = (request_generator) => {
    return `scrapingant${request_generator.cookies ? `&cookies=${request_generator.cookies}` : ""}${request_generator.js_snippet ? `&js_snippet=${request_generator.js_snippet}` : ""}${request_generator.proxy_type && request_generator.proxy_type !== "datacenter"  ? `&proxy_type=${request_generator.proxy_type}` : ""}${request_generator.country && request_generator.country !== "ALL"  ? `&proxy_country=${request_generator.country}` : ""}${!request_generator.browser ? `&browser=false` : ""}${request_generator.return_page_source ? `&return_page_source=true` : ""}${request_generator.wait_for_selector ? `&wait_for_selector=${request_generator.wait_for_selector}` : ""}`
}

export const generateResidentialConnectionString = (residentialRequestGenerator, username, password) => {
    // Base proxy string
    let proxyUserString = `customer-${username}`;

    // Iterate over the residentialRequestGenerator object and add key-value pairs to the string
    for (const [key, value] of Object.entries(residentialRequestGenerator)) {
        if (value) {
            proxyUserString += `-${key}-${value}`.toLowerCase();
        }
    }

    // Add username and password
    proxyUserString += `:${password}`;

    return proxyUserString;
};
